import RedirectActionForm from 'FlowBuilder/components/ActionForms/RedirectActionForm'
import ShareActionForm from 'FlowBuilder/components/ActionForms/ShareActionForm'
import LundaActionForm from 'FlowBuilder/components/ActionForms/LundaActionForm'
import FundraiseUpActionForm from './ActionForms/FundraiseUpActionForm'
import EmailToTargetActionForm from './ActionForms/EmailToTargetActionForm'
import SurveyActionForm from 'FlowBuilder/components/ActionForms/SurveyActionForm'
import DonateActionForm from './ActionForms/DonateActionForm'
import CustomActionForm from './ActionForms/CustomActionForm'
import UnsavedActionForm from './ActionForms/UnsavedActionForm'

import RedirectActionView from 'FlowBuilder/components/ActionViews/Redirect/RedirectActionView'
import SurveyActionView from 'FlowBuilder/components/ActionViews/Survey/SurveyActionView'
import ShareActionView from 'FlowBuilder/components/ActionViews/Share/ShareActionView'
import LundaActionView from 'FlowBuilder/components/ActionViews/Lunda/LundaActionView'
import FundraiseUpActionView from './ActionViews/FundraiseUp/FundraiseUpActionView'
import EmailToTargetActionView from './ActionViews/EmailToTarget/EmailToTargetActionView'
import DonateActionView from './ActionViews/Donate/DonateActionView'
import CustomActionView from './ActionViews/Custom/CustomActionView'

import Setup from './Setup'

import Template from './Template'

export default function Main() {
  const navItem = useSel(s => s.local.navItem)
  const selectedActionId = useSel(s => s.local.selectedActionId)
  const selectedPageNumber = useSel(s => s.local.selectedPageNumber)
  const selectedAction = useSel(s => s.actions.entities[selectedActionId])

  if (navItem === 'build') {
    if (selectedAction) {
      if (selectedAction.id && String(selectedAction.id).includes('-')) {
        return <UnsavedActionForm />
      }
      switch (selectedAction.kind) {
        case 'redirect':
          return <RedirectActionForm actionId={selectedActionId} />
        case 'share':
          return <ShareActionForm actionId={selectedActionId} />
        case 'lunda':
          return <LundaActionForm actionId={selectedActionId} />
        case 'fundraise_up':
          return <FundraiseUpActionForm actionId={selectedActionId} />
        case 'email_to_target':
          return <EmailToTargetActionForm actionId={selectedActionId} />
        case 'survey':
          return <SurveyActionForm actionId={selectedActionId} pageNumber={selectedPageNumber} />
        case 'donate':
          return <DonateActionForm actionId={selectedActionId} />
        case 'custom':
          return <CustomActionForm actionId={selectedActionId} />
        default:
          return <div>Unknown action kind: {selectedAction.kind}</div>
      }
    }
  } else if (navItem === 'preview') {
    if (selectedAction) {
      switch (selectedAction.kind) {
        case 'redirect':
          return <RedirectActionView />
        case 'survey':
          return <SurveyActionView actionId={selectedActionId} pageNumber={selectedPageNumber} />
        case 'share':
          return <ShareActionView actionId={selectedActionId} />
        case 'lunda':
          return <LundaActionView actionId={selectedActionId} />
        case 'fundraise_up':
          return <FundraiseUpActionView actionId={selectedActionId} />
        case 'email_to_target':
          return <EmailToTargetActionView actionId={selectedActionId} />
        case 'donate':
          return <DonateActionView actionId={selectedActionId} />
        case 'custom':
          return <CustomActionView actionId={selectedActionId} />
        default:
          return <div>Unknown action kind: {selectedAction.kind}</div>
      }
    }
  } else if (navItem === 'setup') {
    return <Setup />
  } else if (navItem === 'template') {
    return <Template />
  }

  return null
}
